import { render, staticRenderFns } from "./management.vue?vue&type=template&id=0d76ec84&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76ec84",
  null
  
)

export default component.exports